stimulusApp.register(
  "social-login",
  class extends Stimulus.Controller {
    static values = {
      provider: String,
      url: String,
    }

    #window = null
    #windowWidth = 650
    #windowHeight = 650
    #windowFeatures = Object.entries({
      popup: true,
      width: this.#windowWidth,
      height: this.#windowHeight,
      left: window.screen.width / 2 - this.#windowWidth / 2,
      top: window.screen.height / 2 - this.#windowHeight / 2,
    })
      .flatMap((wf) => wf.join("="))
      .join(",")

    submit() {
      this.#window = window.open("", this.providerValue, this.#windowFeatures)

      // Fallback if popup is blocked
      if (!this.#window) {
        window.location.href = this.urlValue
      }
    }
  },
)
